import React from 'react'
import { Link } from 'react-router-dom'

export type LocationRow = {
  id: number
  google_place_id: string | null
  display_name: string | null
  lat: number | null
  lng: number | null
  category_id: number | null
  active: boolean | null

  // optionale Sprachfelder, damit der Fallback typisiert ist
  name_de?: string | null
  name_en?: string | null
  name_it?: string | null
  name_fr?: string | null
  name_hr?: string | null
  name?: string | null
}

type Props = {
  rows: LocationRow[]
  /** optional: Mapping category_id -> Anzeigename */
  categoryNameById?: Record<number, string>
}

export default function LocationTable({ rows, categoryNameById }: Props) {
  const cell: React.CSSProperties = { padding: '8px 10px', borderBottom: '1px solid #eee' }

  const getDisplayName = (r: LocationRow) =>
    r.name_de ??
    r.name_en ??
    r.name_it ??
    r.name_fr ??
    r.name_hr ??
    r.name ??
    r.display_name ??
    ''

  const catLabel = (id: number | null) => {
    if (id == null) return '—'
    return categoryNameById?.[id] ?? `#${id}`
  }

  const coordLabel = (lat: number | null, lng: number | null) => {
    if (lat == null || lng == null) return '—'
    return `${lat.toFixed(5)}, ${lng.toFixed(5)}`
  }

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white' }}>
      <thead>
        <tr style={{ background: '#f7fafc' }}>
          <th style={cell}>ID</th>
          <th style={cell}>Name</th>
          <th style={cell}>Kategorie</th>
          <th style={cell}>Koord</th>
          <th style={cell}>Aktiv</th>
          <th style={cell}>Bearbeiten</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => {
          const name = getDisplayName(r)
          return (
            <tr key={r.id}>
              <td style={cell}>{r.id}</td>
              <td style={cell}>
                <span title={r.google_place_id || ''}>{name || '—'}</span>
              </td>
              {/* statt ID den Namen anzeigen */}
              <td style={cell}>{catLabel(r.category_id)}</td>
              <td style={cell}>{coordLabel(r.lat, r.lng)}</td>
              <td style={cell}>{r.active ? '✅' : '—'}</td>
              <td style={cell}>
                <Link to={`/c/${r.id}`}>Öffnen</Link>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
